import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ErrorLogsPage } from '@/pages/error-logs';
import { errorLogsSearchSchema } from '@/routes/-shared/errorLogsSearchSchema';
import { requireSuperadmin } from '@/routes/-shared/require-superadmin';

/**
 * Le due viste del registro errori restano montate e il dettaglio di un
 * errore si apre sopra di loro sull'`Outlet` (`$id`), come nella webapp:
 * chiuderlo torna alla vista con filtri e righe aperte di prima.
 */
export const Route = createFileRoute('/admin/_layout/error-logs/_layout')({
  beforeLoad: requireSuperadmin,
  component: ErrorLogsLayout,
  validateSearch: errorLogsSearchSchema,
});

function ErrorLogsLayout() {
  return (
    <>
      <ErrorLogsPage />
      <Outlet />
    </>
  );
}
